import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BaseComponent } from '../../../common/base.component';
import { SelectGearTierComponent } from '../../../common/select/select-gear-tier/select-gear-tier.component';
import { SelectRarityComponent } from '../../../common/select/select-rarity/select-rarity.component';
import { SelectComponent, SelectOptionComponent } from '../../../common/select/select.component';
import { Comparator } from '../../../models/enums';
import { IdentifiedItemConfig, ItemTier, IdentifiedItemConfigType } from '../../../models/filter-models';
import { BaseType } from '../../../models/item-data-models';
import { FilterService } from '../../../services/filter.service';
import { SelectComparatorComponent } from "../../../common/select/select-comparator/select-comparator.component";
import { ModQualityFiltersComponent } from '../../../common/mod-quality-filters/mod-quality-filters.component';

@Component({
  selector: 'app-identified-item-configuration',
  imports: [FormsModule, SelectGearTierComponent, SelectComponent, SelectOptionComponent,
    SelectRarityComponent, SelectComparatorComponent, ModQualityFiltersComponent,
    // AdvancedEquipmentConditionsComponent, MyEquipmentHighlightsComponent, TooltipWrapperComponent, AutocompleteComponent
  ],
  templateUrl: './identified-item-configuration.component.html',
  styleUrl: './identified-item-configuration.component.scss'
})
export class IdentifiedItemConfigurationComponent extends BaseComponent implements OnInit {
  @Input({ required: true }) identifiedItemConfig!: IdentifiedItemConfig;
  @Input({ required: true }) index!: number;
  @Output() remove = new EventEmitter<number>();

  conditionsOpen = false;

  itemTypes: BaseType[] = [];

  derivedName?: string;

  IdentifiedItemConfigType = IdentifiedItemConfigType;
  ItemTier = ItemTier;

  // cosmeticOptionsExcellentGear?: CosmeticOptions;

  constructor(private filterService: FilterService) {
    super();
  }

  ngOnInit(): void {
    this.deriveName();
    // TODO: load item types

    // this.cosmeticOptionsExcellentGear = this.cosmeticsGeneratorService.getCosmeticOptionsFromDisplayOptions(
    //   this.helper.getEquipmentTierDisplayOptionsByType(EquipmentType.OtherExcellentIdentifiedGear, true)
    // ).cosmeticOptions;
  }

  toggleEnabled() {
    this.identifiedItemConfig.enabled = !this.identifiedItemConfig.enabled;
    if (!this.identifiedItemConfig.enabled) {
      this.conditionsOpen = false;
    }
    this.updateFilter();
  }

  removeIdentifiedItemConfiguration() {
    this.remove.emit(this.index);
  }

  updateFilter() {
    this.filterService.updateFilter();
    this.deriveName();
  }

  deriveName() {
    this.derivedName = this.identifiedItemConfig.itemTier === ItemTier.Excellent ? 'Excellent' : this.identifiedItemConfig.itemTier === ItemTier.Good ? 'Good' : '';
    this.derivedName += ' ' + this.identifiedItemConfig.rarity + (this.identifiedItemConfig.rarityComparator === Comparator.GreaterThanOrEqual ? '+' : '');
    this.derivedName += ' ' + this.identifiedItemConfig.type;
  }
}
